export default [
  {
    path: '/chunjie',
    name: 'page_home',
    meta: {
      keepAlive: false,
      title: '工会知识答题闯关'
    },
    component: resolve => {
      require(['../views/chunjie/home'], resolve)
    }
  },
  {
    path: '/chunjie/fokas',
    name: 'page_fokas',
    meta: {
      keepAlive: false,
      title: '集福卡'
    },
    component: resolve => {
      require(['../views/chunjie/fokas'], resolve)
    }
  },
  {
    path: '/chunjie/myfokas',
    name: 'page_myfokas',
    meta: {
      keepAlive: false,
      title: '我的福卡'
    },
    component: resolve => {
      require(['../views/chunjie/myfokas'], resolve)
    }
  },
  {
    path: '/chunjie/caidengmi',
    name: 'page_index',
    meta: {
      keepAlive: false,
      title: '猜灯谜'
    },
    component: resolve => {
      require(['../views/chunjie/cdmindex'], resolve)
    }
  },
  {
    path: '/chunjie/list',
    name: 'page_list',
    meta: {
      keepAlive: false,
      title: '猜灯谜'
    },
    component: resolve => {
      require(['../views/chunjie/list'], resolve)
    }
  },
  {
    path: '/chunjie/form',
    name: 'chunjie_form',
    meta: {
      keepAlive: false,
      title: '猜灯谜'
    },
    component: resolve => {
      require(['../views/chunjie/form'], resolve)
    }
  },
  {
    path: '/chunjie/lottery',
    name: 'chunjie_lottery',
    meta: {
      keepAlive: false,
      title: '抽奖'
    },
    component: resolve => {
      require(['../views/chunjie/lottery'], resolve)
    }
  },
  {
    path: '/chunjie/exchange',
    name: 'chunjie_exchange',
    meta: {
      keepAlive: false,
      title: '兑换答题次数'
    },
    component: resolve => {
      require(['../views/chunjie/exchange'], resolve)
    }
  },
  {
    path: '/chunjie/present',
    name: 'chunjie_present',
    meta: {
      keepAlive: false,
      title: '赠送福卡'
    },
    component: resolve => {
      require(['../views/chunjie/present'], resolve)
    }
  },
  {
    path: '/chunjie/getfudai',
    name: 'chunjie_getfudai',
    meta: {
      keepAlive: false,
      title: '兑换福袋'
    },
    component: resolve => {
      require(['../views/chunjie/getfudai'], resolve)
    }
  },
  {
    path: '/chunjie/test',
    name: 'chunjie_test',
    meta: {
      keepAlive: false,
      title: 'test'
    },
    component: resolve => {
      require(['../views/chunjie/test'], resolve)
    }
  }
]
